import {
    getRiskLevelBySecurityScore,
    RISKS_CONFIG,
    SEVERITY_CONFIG,
} from '@/ui/utils/utils'
import { FC } from 'react'
import {
    TextAndIconWrapper,
    SeverityIndicatorWrapper,
    SeverityText,
} from './SeverityIndicator.styles'
import SeverityIndicatorIcon from '../svg/SeverityIndicatorIcon'

interface SeverityIndicatorProps {
    severity: TIssueSeverity
}

const SeverityIndicator: FC<SeverityIndicatorProps> = ({ severity }) => {
    const text = SEVERITY_CONFIG[severity].text
    return (
        <SeverityIndicatorWrapper
            severity={severity}
            data-testid="severity-indicator"
        >
            <TextAndIconWrapper>
                <SeverityIndicatorIcon
                    dataTestId={`severity-${severity}`}
                    severity={severity ?? 'clean'}
                />
                <SeverityText component="span" variant="s-bold">
                    {text}
                </SeverityText>
            </TextAndIconWrapper>
        </SeverityIndicatorWrapper>
    )
}

export default SeverityIndicator
